module.exports = __webpack_public_path__ + "static/media/nifty.9b1d1bea.png";